module.exports = __webpack_public_path__ + "36a6c1344d3bc5f35397bacecd2a6f0b.svg";